'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    importance: 'MEDIUM',
    periodType: 'Monthly',
    operator: 'not_equal_to',
    leftSide: {
        missingValueStrategy: 'NEVER_SKIP',
        description: '',
        expression: ''
    },
    rightSide: {
        missingValueStrategy: 'NEVER_SKIP',
        description: '',
        expression: ''
    }
};
//# sourceMappingURL=validationRule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/validationRule.js
// module id = 385
// module chunks = 0